import { authInfoSelect } from "@entities/auth";
import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import * as S from "../../style/Sidebar.styled";

interface PropsSidebar {
  sidemenu: any;
}

const Sidebar = ({ sidemenu }: PropsSidebar) => {
  const { pathname } = window.location;
  const [click, setClick] = useState(false);
  const [activeMenuItemPath, setActiveMenuItemPath] = useState(pathname);
  const { user } = useSelector(authInfoSelect);
  const activeItemRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    setActiveMenuItemPath(pathname);
  }, [pathname]);

  const handleClick = () => setClick(!click);

  return (
    <>
      {user && (
        <S.Nav key={"sidebar"}>
          <S.Menu onClick={handleClick}>
            {sidemenu?.map((item, ind) =>
              item.isAllow ? (
                <S.StyledStage key={ind + item.to}>
                  <S.MenuLink to={item.to} key={`link-${item.text}`}>
                    <S.StyledLinkWrap
                      ref={
                        activeMenuItemPath.includes(item.to)
                          ? activeItemRef
                          : null
                      }
                      $activeitem={
                        activeMenuItemPath.includes(item.to) ? "true" : ""
                      }
                      key={item.text}
                      $pathname={pathname}
                    >
                      <div>{item.icon}</div>
                      <S.StyledTextWrap>{item.name}</S.StyledTextWrap>
                    </S.StyledLinkWrap>
                  </S.MenuLink>
                  <S.StyledSubs>
                    {item?.subs?.map((obj, i) =>
                      obj.isAllow ? (
                        <S.SubLink key={obj.to + i} to={obj.to}>
                          {obj.name}
                        </S.SubLink>
                      ) : null
                    )}
                  </S.StyledSubs>
                </S.StyledStage>
              ) : null
            )}
          </S.Menu>
        </S.Nav>
      )}
    </>
  );
};

export default Sidebar;
